import React from 'react';
import { FormattedMessage } from 'react-intl';
import FirebaseEventManager from './utils/firebaseEventManager.js';
import './styles/footer.css';

export default function Footer (props) {
  const isInSignIn = props.detectIsSignInPage();
  const firebaseEventManager = new FirebaseEventManager();
  function clickTS () {
    if (isInSignIn) {
      firebaseEventManager.signInPageClickItem({
        item: 'terms'
      })
    }
    window.open(props.terms || 'https://alfred.camera/legal/terms-of-service');
  }
  function clickPP () {
    if (isInSignIn) {
      firebaseEventManager.signInPageClickItem({
        item: 'privacy',
      });
    }
    window.open(props.privacy || 'https://alfred.camera/legal/privacy-policy');
  }
  function clickFAQ () {
    if (isInSignIn) {
      firebaseEventManager.signInPageClickItem({
        item: 'faq',
      });
    }
    window.open(props.FAQ || 'https://alfredcamera.zendesk.com/hc');
  }

  return (
    <div className="login-footer">
      <p className="footer-item" onClick={clickTS}>
        <FormattedMessage id="footer_terms_of_service" />
      </p>
      <p className="footer-item" onClick={clickPP}>
        <FormattedMessage id="footer_privacy_policy" />
      </p>
      <p className="footer-item" onClick={clickFAQ}>
        <FormattedMessage id="footer_faq" />
      </p>
      <p className="footer-item claim">© 2024 Alfred Systems Inc. All rights reserved.</p>
    </div>
  );
}
